<template>
		<div id="pageRoot">

			<p id="text01">
Pero lo peor fue el lío de la cancha. Venancio pasó volando por el campo justo en el momento en que la pelota estaba por entrar al arco, y la pelota, en lugar de hacer gol, fue a parar a la tribuna, junto con Venancio. Los que se habían perdido el gol se pusieron furiosos y comenzaron a gritarles y patearlos y a morderles las orejas a los que se habían salvado del gol.<br><br>
Los que se habían salvado del gol se defendían lo mejor que podían.<br><br>
—La culpa no es nuestra —decían mientras se tapaban con las dos manos las orejas—, la culpa la tiene el perro.<br><br>
El barrio entero se enojó con Venancio y con don Fito, el dueño de Venancio.<br><br>
—Los perros voladores son muy molestos— decían.<br><br>
—¡Son peores que las moscas!<br><br>
Y los chicos se ponían a saltar en la vereda y gritaban:<br><br>
—¡Que-no-vuele! ¡Que-no-vuele!<br><br>
Desde ese día Venancio ya no vuelta tanto por el barrio.<br><br>
			</p>

			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
			<span class="footer-page footer-listen"></span>
			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		</div>
</template>
<style scoped>
#text01
{
position: absolute;
left: 4.98%;
right: 4.98%;
top: 7.68%;
bottom: 13.28%;
margin: 0px;
z-index: 3;

font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 22px;
line-height: 28px;

color: #000000;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p53-57/V16.mp4"]
    }
  }
}
</script>